import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { FurnitureCategory } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 0.7;
const DEFAULT_HEIGHT = 0.7;

const Plant: C1_FurnitureDefinition = {
  id: "plant",
  icon: <C1_FurnitureIcon kind="plant" />,
  description: { en: "Potted plant", de: "Topfpflanze" },
  category: FurnitureCategory.Decoration,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
      >
        <ellipse
          cx={width / 2}
          cy={height / 2}
          rx={Math.max(0, width / 2 - 0.04 * PX)}
          ry={Math.max(0, height / 2 - 0.04 * PX)}
          fill={finalFillColor}
          stroke={finalStrokeColor}
          strokeWidth={finalStrokeWidth * 2}
        />
        {showDetails && (
          <>
            <path
              d={`M${width / 2} ${height / 2} C${width * 0.29} ${height * 0.11}, ${width * 0.17} ${height * 0.4}, ${width / 2} ${height / 2} C${width * 0.83} ${height * 0.11}, ${width * 0.94} ${height * 0.4}, ${width / 2} ${height / 2} Z`}
              fill="none"
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
            <path
              d={`M${width / 2} ${height / 2} C${width * 0.17} ${height * 0.6}, ${width * 0.34} ${height * 0.89}, ${width / 2} ${height / 2} C${width * 0.83} ${height * 0.6}, ${width * 0.66} ${height * 0.89}, ${width / 2} ${height / 2} Z`}
              fill="none"
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
          </>
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default Plant;
